<template>

  <v-dialog v-model="dialog" scrollable max-width="500px">
    <v-card>
      <v-card color="blue">
        <v-card-title flat class='white--text title' :title="configName">{{cardTitle}}</v-card-title>
      </v-card>

      <!--<v-card color="transparent" flat>
        <v-card-text class="font-weight-light text-xs-left title underlineheadline bluetext">
          {{cardTitle}}
        </v-card-text>
      </v-card>-->
      <v-card-text style="height: 300px;" class="smallspacedialog pt-0">
        <!--<v-layout row wrap justify-start>
          <v-flex>
            <v-card flat>
              <v-card-title>
                {{description}}
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>-->

        <span v-for="col in columns">
          <v-checkbox v-if='isShown(col)' :label="'' + col.text + ''" v-model="col.isVisible" @change="onchangeState(col)" color="#004884">{{col}}</v-checkbox>
        </span>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="dialog=false" color="#004884" small dark outline class="radiusBtn text-none">{{'BUTT_CANCEL' | translate}}</v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="onUse()" color="#004884" small dark class="radiusBtn text-none">{{'BUTT_USE' | translate}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue'
var _ = require('lodash')
export default {
  name: 'DialogTableColumns',
  components: {},
  props: ['configName'],
  methods: {
    isShown: function (col) {
      return ('' + col.text).trim().length > 0
    },
    /**
     * newName, title, type
     * @param cardConfig
     */
    onUse: function () {
      this.dialog = false
      var columns = []
      for (var ic in this.columnList) {
        var c = this.columnList[ic]
        if (c.isVisible) {
          columns.push(c)
        }
      }
      Vue.prototype.storage.saveState(this.configName, this.columns)
      this.$emit('doChangeColumns', columns)
    },
    onchangeState: function (a, b, c) {
      Vue.prototype.$api.debug('onchangeState', a, b, c)
      // saved in IETable
      ///Vue.prototype.storage.saveState('TableColumns' + this.configName, this.columns)
    },
    getValue: function (column) {
      Vue.prototype.$api.debug('column', column, this.columnList)
    },
    open: function (cardConfig) {
      this.columnList = []
      if ((cardConfig != null) && (cardConfig)) {
        this.newName = cardConfig.newName
        this.cardTitle = cardConfig.title
        this.type = cardConfig.type
        this.description = cardConfig.description
        this.columns = _.clone(cardConfig.columns, true)
        // this.columns =
        // this.columns.splice(0, 1)
        this.columnList = this.columnList.concat(this.columns)
      }
      let cmp = this
      this.userDefinedColumns = Vue.prototype.storage.getState(this.configName,[])
      if (this.userDefinedColumns && this.userDefinedColumns.length > 0) {
        _.forEach(this.userDefinedColumns, function (c) {
          let curIndex = _.findIndex(cmp.columns, function (o) {
            return c.id === o.id
          })
          // console.log('c',c, curIndex, cmp.columns)
          if (curIndex > -1) {
            cmp.columns[curIndex].visible = c.visible
          }
        })
      }

      this.dialog = true
    }
  },
  data () {
    return {
      cardTitle: 'Login nicht erfolgreich',
      type: 'group',
      columnList: [],
      userDefinedColumns: [],
      pwOld: '',
      pwNew: '',
      pwNew2: '',
      columns: [],
      imageLayout: '0',
      questionTyp: '1',
      mySubjects: {},
      description: '',
      dialog: false
    }
  },
  mounted () {
    //
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/dialogs/DialogTableColumns.vue